const routes = [
  {
    path: "/books/catalog",
    name: "inventory-catalog-books",
    component: () => import("@/views/books/inventoryCatalog/Main")
  },
  {
    path: "/books/catalog/:id",
    name: "inventory-catalog-books-management",
    component: () => import("@/views/books/inventoryCatalog/Management/Main")
  },
  {
    path: "/books/catalog/:id/load",
    name: "inventory-catalog-books-load",
    component: () => import("@/views/books/inventoryCatalog/Load/Main")
  },
  {
    path: "/books/catalog/:id/edit/:bookId",
    name: "inventory-catalog-books-edit",
    component: () => import("@/views/books/inventoryCatalog/Load/Main")
  },
  {
    path: "books/catalog/:id/details/:bookId",
    name: "InventoryBookDetails",
    component: () => import("@/views/books/inventoryCatalog/details/Main.vue")
  },
  {
    path: '/books/BooksCatalog/:id/add/:bookId',
    name: 'inventory-catalog-books-add',
    component: () => import("@/views/books/inventoryCatalog/Load/AddInventory.vue")
  },
  {
    path: "/books/inventory-order-books",
    name: "",
    component: () => import("@/views/books/inventoryOrderBooks/Wrapper"),
    children: [
      {
        path: "",
        name: "inventoryOrderBooks",
        component: () => import("@/views/books/inventoryOrderBooks/Main")
      },
      {
        path: "add",
        name: "inventoryOrderBooksAdd",
        component: () => import("@/views/books/inventoryOrderBooks/add/Main")
      }
    ]
  },
  {
    path: "/books/requests",
    name: "",
    component: () => import("@/views/books/requests/Wrapper"),
    children: [
      {
        path: "",
        name: "requestsBooks",
        component: () => import("@/views/books/requests/Main")
      }
    ]
  },
  {
    path: "/books/transfers",
    name: "",
    component: () => import("@/views/books/inventoryTranfers/Wrapper"),
    children: [
      {
        path: "",
        name: "inventoryTranferBooks",
        component: () => import("@/views/books/inventoryTranfers/Main")
      }
    ]
  },
  {
    path: "/books/requests/:id/inventory",
    name: "",
    component: () => import("@/views/books/inventoryRequestsBooks/Wrapper"),
    children: [
      {
        path: "",
        name: "inventoryRequestsBooks",
        component: () => import("@/views/books/inventoryRequestsBooks/Main")
      },
    ]
  }
];
export default routes;
